import { render, staticRenderFns } from "./w-btn-close.vue?vue&type=template&id=80692970&lang=pug&"
import script from "./w-btn-close.vue?vue&type=script&lang=js&"
export * from "./w-btn-close.vue?vue&type=script&lang=js&"
import style0 from "./w-btn-close.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80692970')) {
      api.createRecord('80692970', component.options)
    } else {
      api.reload('80692970', component.options)
    }
    module.hot.accept("./w-btn-close.vue?vue&type=template&id=80692970&lang=pug&", function () {
      api.rerender('80692970', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-btn-close.vue"
export default component.exports